import { Navigate } from "react-router-dom";
import { useUser } from "./useUser";

/**
 * Wraps a route that only Admin users may open. Non-admins are sent to the
 * unauthorized page rather than the API, which would answer 403 and log them
 * out via the axios interceptor.
 */
export const AdminRoute = ({ children }) => {
  const user = useUser();

  if (!user) return <Navigate to="/login" />;
  if (user.role !== "Admin" && !user.isSuperadmin) {
    return <Navigate to="/unauthorized" />;
  }
  return children;
};
